export default "__VITE_ASSET__BzkJvhfe__"